// src/pages/Home.jsx
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { BsStarFill } from 'react-icons/bs';
import { FaExchangeAlt, FaShieldAlt, FaGlobeAmericas } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';


const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const { user } = useAuth();

  // Función para renderizar estrellas: recibe total y cuántas "llenas"
  const renderStars = (total = 5, full = 4) => {
    const stars = [];
    for (let i = 0; i < full; i++) {
      stars.push(<BsStarFill key={`star-full-${i}`} style={{ color: 'orange'
       }} />);
    }
    for (let i = full; i < total; i++) {
      // Aplica opacidad para simular la versión "muted"
      stars.push(<BsStarFill key={`star-muted-${i}`} style={{ opacity: 0.5 }} />);
    }
    return stars;
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="hero-section" id="hero">
        <div className="wave">
          <svg width="100%" height="355px" viewBox="0 0 1920 355" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFFFFF">
              <path d="M0,439.134243 C175.04074,464.89273 327.944386,477.771974 458.710937,477.771974 C654.860765,477.771974 870.645295,442.632362 1205.9828,410.192501 C1429.54114,388.565926 1667.54687,411.092417 1920,477.771974 L1920,757 L1017.15166,757 L0,757 L0,439.134243 Z"></path>
            </g>
          </svg>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 hero-text-image">
              <div className="row">
                <div className="col-lg-8 text-center text-lg-start" data-aos="fade-right">
                  <h1>Envía y Recibe Divisas al Instante</h1>
                  <p className="mb-5">
                    Con Smart Money puedes enviar y recibir USD, Euros, Bs, COP y más. Aprovecha tasas actualizadas en tiempo real.
                  </p>
                  <p data-aos="fade-right" data-aos-delay="200">                    
                  {user ? (
                          <a href="/envios" className="btn btn-outline-white">Realizar Envío</a>
                  ) : (
                    <a href="/login" className="btn btn-outline-white">Realizar Envío</a>
                  )}
                  </p>
                </div>
                <div className="col-lg-4 iphone-wrap" data-aos="fade-left">
                  <img src="/assets/img/phone_1.png" alt="Smart Money App" className="phone-1" />
                  <img src="/assets/img/phone_2.png" alt="Smart Money App" className="phone-2" data-aos-delay="200" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ¿Cómo Funciona? Section */}
      <section className="section" id="como-funciona">
        <div className="container">
          <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
            <div className="col-md-6">
              <h2 className="section-heading">¿Cómo Funciona Smart Money?</h2>
              <p>Un proceso sencillo para enviar y recibir divisas en todo el mundo.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4" data-aos="fade-up">
              <div className="step text-center">
              <span className="number">01</span>
                <h3>Regístrate</h3>
                <p>Crea tu cuenta de forma rápida y segura para comenzar a operar.</p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="step text-center">
                <span className="number">02</span>
                <h3>Realiza el Envío</h3>
                <p>Configura tu transacción seleccionando las divisas y métodos de pago adecuados.</p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="step text-center">
                <span className="number">03</span>
                <h3>Tasas en Tiempo Real</h3>
                <p>Consulta y aprovecha las tasas de cambio actualizadas para obtener el mejor valor.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Características Destacadas */}
      <section className="section bg-light" id="caracteristicas">
        <div className="container">
          <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
            <div className="col-md-6">
              <h2 className="section-heading">Características de Smart Money</h2>
              <p>Transacciones rápidas, seguras y con las mejores tasas.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4" data-aos="fade-up">
              <div className="feature text-center">
                <div className="wrap-icon icon-1 mb-4">
                <FaExchangeAlt size={48} style={{ color: '#fff' }} />
                </div>
                <h3 className="mb-3">Tasas Actualizadas</h3>
                <p>Consulta tasas de cambio en tiempo real gracias a nuestra API integrada.</p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="feature text-center">
                <div className="wrap-icon icon-1 mb-4">
                <FaShieldAlt size={48} style={{ color: '#fff' }} />
                </div>
                <h3 className="mb-3">Transacciones Seguras</h3>
                <p>Protegemos tus fondos con altos estándares de seguridad.</p>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="feature text-center">
                <div className="wrap-icon icon-1 mb-4">
                <FaGlobeAmericas size={48} style={{ color: '#fff' }} />

                </div>
                <h3 className="mb-3">Soporte Multidivisa</h3>
                <p>Realiza envíos y recepciones en cualquier dirección: USD, Euros, Bs, COP, etc.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="section border-top border-bottom" id="testimonios">
        <div className="container">
          <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
            <div className="col-md-6">
              <h2 className="section-heading">Lo que dicen nuestros usuarios</h2>
              <p>Historias reales de quienes confían en Smart Money.</p>
            </div>
          </div>
          <div className="row justify-content-center text-center">
            <div className="col-md-8">
              <Swiper
                spaceBetween={30}
                pagination={{ clickable: true }}
                modules={[Pagination]}
                className="mySwiper"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <SwiperSlide>
                  <div className="review text-center">
                    <p className="stars">
                    {renderStars(5, 4)}
                    </p>
                    <h3>¡Excelente plataforma!</h3>
                    <blockquote>
                      <p>Smart Money facilitó el envío de dinero a mi familia de forma rápida y segura.</p>
                    </blockquote>
                    <p className="review-user">
                      <img src="/assets/img/person_1.jpg" alt="Usuario" className="img-fluid rounded-circle mb-3" />
                      <span className="d-block"><strong>María González</strong>, Usuario</span>
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="review text-center">
                    <p className="stars">
                    {renderStars(5, 4)}
                    </p>
                    <h3>¡Muy confiable!</h3>
                    <blockquote>
                      <p>Las tasas en tiempo real me dan la seguridad de estar siempre informado sobre mis transacciones.</p>
                    </blockquote>
                    <p className="review-user">
                      <img src="/assets/img/person_2.jpg" alt="Usuario" className="img-fluid rounded-circle mb-3" />
                      <span className="d-block"><strong>Carlos Pérez</strong>, Usuario</span>
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="review text-center">
                    <p className="stars">
                    {renderStars(5, 4)}
                    </p>
                    <h3>¡Recomendada!</h3>
                    <blockquote>
                      <p>Con Smart Money envío dinero a mis contactos de forma sencilla y sin complicaciones.</p>
                    </blockquote>
                    <p className="review-user">
                      <img src="/assets/img/person_3.jpg" alt="Usuario" className="img-fluid rounded-circle mb-3" />
                      <span className="d-block"><strong>Ana Ramírez</strong>, Usuario</span>
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="section cta-section" id="cta">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start" data-aos="fade-up">
              <h2>Únete a Smart Money hoy mismo</h2>
              <p>Empieza a enviar y recibir divisas de forma rápida y segura.</p>
            </div>
            <div className="col-md-6 text-center text-md-end" data-aos="fade-up" data-aos-delay="100">
              <a href="/registro" className="btn btn-primary">Regístrate Ahora</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
